const spefificationsColumns = {
  groupingId: {
    key: 'groupingId',
    label: 'groupCode',
    type: 'function',
    sortable: false,
    minWidth: 150,
    get: (value, row) => (row.children ? value : ''),
  },
  customerId: {
    key: 'customerId',
    label: 'customerId',
    type: 'text',
    sortable: false,
    minWidth: 100,
  },
  customerProductCode: {
    key: 'customerProductCode',
    label: 'customerProductCode',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  sequence: {
    key: 'sequence',
    label: 'sequence',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  operation: {
    key: 'operation',
    label: 'operation',
    type: 'text',
    minWidth: 200,
    sortable: false,
  },
  expectedValue: {
    key: 'expectedValue',
    label: 'expectedValue',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  measure: {
    key: 'description',
    label: 'measure',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  type: {
    key: 'type',
    label: 'specificationType',
    type: 'text',
    minWidth: 100,
    sortable: false,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    align: 'center',
    minWidth: 100,
    buttons: [
      {
        name: 'editSpecification',
        icon: 'fas fa-pencil',
        permissions: ['operationsManage'],
        showCondition: (row) => !row.children,
      },
      {
        name: 'deleteSpecification',
        icon: 'fas fa-trash-alt',
        permissions: ['operationsManage'],
        showCondition: (row) => !row.children,
      },
    ],
  },
};

export default spefificationsColumns;
